import React, { createContext, useContext, useEffect, useState } from 'react';
import { darkTheme, lightTheme } from '../styles/themes';

const ThemeContext = createContext(null);

function resolveTheme(mode) {
  if (mode === 'light') return 'light';
  if (mode === 'dark')  return 'dark';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function ThemeProvider({ children }) {
  const [themeMode, setThemeModeState] = useState(
    () => localStorage.getItem('jahbath_theme') || 'system'
  );
  const [theme, setTheme] = useState(() => resolveTheme(
    localStorage.getItem('jahbath_theme') || 'system'
  ));

  useEffect(() => {
    if (themeMode !== 'system') return;
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = () => setTheme(mq.matches ? 'dark' : 'light');
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [themeMode]);

  const setThemeMode = (mode) => {
    localStorage.setItem('jahbath_theme', mode);
    setThemeModeState(mode);
    setTheme(resolveTheme(mode));
  };

  const T = theme === 'dark' ? darkTheme : lightTheme;

  return (
    <ThemeContext.Provider value={{ theme, themeMode, setThemeMode, T }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
